import { useNicheTableModel } from './niche-table.model'
import type { INicheTable } from './niche-table.types'
import { NicheTableView } from './niche-table.view'

export const NicheTable = (props: INicheTable) => {
  const nicheTableModel = useNicheTableModel(props)
  return <NicheTableView {...nicheTableModel} />
}
